/* ao-recipe.js — Portionsrechner + Abhak-Zutaten (Design-Umbau R2, 2026-07-18).
   Progressive Enhancement: Der Server rendert die ORIGINAL-Mengen (SEO, Print,
   Screenreader und das Recipe-JSON-LD bleiben unangetastet). Dieses Skript kapselt
   die führende Menge jeder Zutat und skaliert sie relativ zur Portionszahl. Fehlt
   eine parsbare Portionszahl oder hat keine Zutat eine führende Menge, bleibt der
   Rechner verborgen — die Zutaten stehen dann einfach im Originaltext. */
(function () {
  'use strict';

  // Führende Menge: gemischter Bruch "1 1/2", Bruch "1/2", Dezimal "70" / "0,5" / "1.5"
  var ZAHL = /^\s*(\d+\s+\d+\/\d+|\d+\/\d+|\d+(?:[.,]\d+)?)/;

  function parseFuehrend(text) {
    var m = text.match(ZAHL);
    if (!m) return null;
    var raw = m[1];
    var val;
    if (raw.indexOf('/') !== -1) {
      var teile = raw.trim().split(/\s+/);
      if (teile.length === 2) { // "1 1/2"
        var b = teile[1].split('/');
        val = parseInt(teile[0], 10) + parseInt(b[0], 10) / parseInt(b[1], 10);
      } else {
        var f = raw.split('/');
        val = parseInt(f[0], 10) / parseInt(f[1], 10);
      }
    } else {
      val = parseFloat(raw.replace(',', '.'));
    }
    if (!isFinite(val) || val <= 0) return null;
    // Länge inkl. führender Whitespace, damit der Rest sauber abgetrennt wird
    return { raw: m[1], vollLen: m[0].length, val: val };
  }

  var BRUCH = { 0.25: '¼', 0.5: '½', 0.75: '¾' };
  function formatMenge(v) {
    var r;
    if (v >= 10) r = Math.round(v);
    else if (v >= 1) r = Math.round(v * 2) / 2;      // halbe Schritte
    else r = Math.round(v * 4) / 4;                   // viertel Schritte
    if (r === 0) r = Math.round(v * 100) / 100;       // sehr klein: nicht auf 0 runden
    // Küchenbrüche schöner als Dezimal: 0,5 → ½, 1,25 → 1¼ …
    var ganz = Math.floor(r);
    var rest = Math.round((r - ganz) * 100) / 100;
    if (BRUCH[rest]) return (ganz ? String(ganz) : '') + BRUCH[rest];
    return (r % 1 === 0 ? String(r) : String(r)).replace('.', ',');
  }

  function initRezept(container) {
    // 1) Führende Menge jeder Zutat kapseln — nur den ersten Text-Node teilen,
    //    damit etwaige Inline-Links (Redaktion) unangetastet bleiben.
    var mengen = [];
    container.querySelectorAll('.ao-recipe__zutat-text').forEach(function (span) {
      var first = span.firstChild;
      if (!first || first.nodeType !== 3) return;
      var p = parseFuehrend(first.textContent);
      if (!p) return;
      var mengeSpan = document.createElement('span');
      mengeSpan.setAttribute('data-menge', '');
      mengeSpan.setAttribute('data-basis', String(p.val));
      mengeSpan.textContent = p.raw;
      // Rest OHNE extra Leerzeichen: der Originaltext trägt den Abstand nach der
      // Zahl bereits (" g Butter"); ein zusätzliches würde "70  g" ergeben.
      var rest = document.createTextNode(first.textContent.slice(p.vollLen));
      span.replaceChild(rest, first);
      span.insertBefore(mengeSpan, rest);
      mengen.push(mengeSpan);
    });

    // 2) Portionsrechner nur, wenn Portionszahl UND mindestens eine Menge parsbar.
    // Ein Naeherungs-Praefix darf den Rechner nicht blockieren: „ca. 2 l" -> „2 l".
    // Nur hier, nicht in parseFuehrend selbst -- bei Zutaten muss die Zahl am Anfang
    // stehen bleiben, sonst wuerde „Saft von 2 Zitronen" mitskaliert.
    var servRaw = container.getAttribute('data-servings') || '';
    var servTxt = servRaw.replace(/^\s*(?:ca\.?|etwa|ungef(?:ä|ae)hr)\s+/i, '');
    var pServ = parseFuehrend(servTxt);
    var box = container.querySelector('[data-ao-portionen]');
    if (pServ && mengen.length && box) {
      var basis = pServ.val;
      var einheit = servTxt.slice(pServ.vollLen).trim();
      var aktuell = basis;
      var zahlEl = box.querySelector('[data-ao-portionen-zahl]');
      var einheitEl = box.querySelector('[data-ao-portionen-einheit]');
      var minus = box.querySelector('[data-ao-minus]');
      var plus = box.querySelector('[data-ao-plus]');

      var setzen = function () {
        zahlEl.textContent = formatMenge(aktuell);
        var faktor = aktuell / basis;
        mengen.forEach(function (el) {
          el.textContent = formatMenge(parseFloat(el.getAttribute('data-basis')) * faktor);
        });
      };
      einheitEl.textContent = einheit;
      setzen();
      minus.addEventListener('click', function () { if (aktuell > 1) { aktuell -= 1; setzen(); } });
      plus.addEventListener('click', function () { aktuell += 1; setzen(); });
      box.hidden = false;
    }

    // 3) Abhaken (unabhängig vom Rechner): Klick toggelt die Beeren-Checkbox.
    container.querySelectorAll('.ao-recipe__check').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var an = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', an ? 'false' : 'true');
        var li = btn.closest('.ao-recipe__zutat');
        if (li) li.classList.toggle('is-done', !an);
      });
    });
    var tipp = container.querySelector('[data-ao-tipp]');
    if (tipp) tipp.hidden = false;
  }

  function boot() {
    document.querySelectorAll('[data-ao-recipe]').forEach(initRezept);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
